import { createRoot } from 'react-dom';

import 'swiper/css/bundle';
import './style.scss';
import Style from './Components/Common/Style';
import Slider from './Components/Common/Slider';

document.addEventListener('DOMContentLoaded', () => {
	const blockEls = document.querySelectorAll('.wp-block-evb-slider');
	blockEls.forEach((blockEl, index) => {
		blockEl.id = `evssSlider-${index}`;

		const attributes = JSON.parse(blockEl.dataset.attributes);

		createRoot(blockEl).render(<>
			<Style attributes={attributes} clientId={index} />

			<Slider attributes={attributes} Content={SlideContent} />
		</>, blockEl);

		blockEl?.removeAttribute('data-attributes');
	});
});

const SlideContent = ({ content }) => {
	const mainContent = content.replace('<p></p>', '');

	return mainContent && <div className='slideContent' dangerouslySetInnerHTML={{ __html: content.replace('<p></p>', '') }} />
}